import {createAction} from '@reduxjs/toolkit';
import {ListMoviesResult} from '../../graph/movie';

export const addListMoviesQueryResult =
  createAction<{page: 'movies_index'; result: ListMoviesResult}>('movies/updateListMovies');
